var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92.383px",
    height: "78.320395px",
    viewBox: "0 0 92.383 78.320395",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "computer_purple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computer_purple",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.766,64.453 L82.618,64.453 C85.678,64.453 88.071,63.582 89.796,61.841 C91.521,60.1 92.383,57.715 92.383,54.688 L92.383,9.766 C92.383,6.706 91.521,4.313 89.796,2.588 C88.071,0.863 85.677,-2.44422538e-15 82.617,-2.44422538e-15 L9.766,-2.44422538e-15 C6.706,-2.44422538e-15 4.314,0.863 2.588,2.588 C0.862,4.313 1.22124533e-15,6.706 1.22124533e-15,9.766 L1.22124533e-15,54.688 C1.22124533e-15,57.715 0.863,60.1 2.588,61.841 C4.313,63.582 6.706,64.453 9.766,64.453 Z M8.594,47.021 C7.552,47.021 7.031,46.516 7.031,45.507 L7.031,9.863 C7.031,7.975 7.975,7.031 9.863,7.031 L82.519,7.031 C84.407,7.031 85.351,7.975 85.351,9.863 L85.351,45.508 C85.351,46.517 84.83,47.022 83.789,47.022 L8.594,47.022 L8.594,47.021 Z M33.887,73.242 L58.545,73.242 L58.545,63.965 L33.887,63.965 L33.887,73.242 Z M33.838,78.32 L58.594,78.32 C59.538,78.32 60.36,77.978 61.06,77.295 C61.7440908,76.6492451 62.125141,75.7456117 62.11,74.805 C62.1223746,73.8576289 61.7423314,72.9473348 61.06,72.29 C60.36,71.59 59.538,71.24 58.594,71.24 L33.838,71.24 C32.8906289,71.2276254 31.9803348,71.6076686 31.323,72.29 C30.6406686,72.9473348 30.2606254,73.8576289 30.273,74.805 C30.257859,75.7456117 30.6389092,76.6492451 31.323,77.295 C31.9872576,77.9641694 32.8952255,78.334216 33.838,78.32 L33.838,78.32 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerPurple);
export default __webpack_public_path__ + "static/media/computer_purple.ebe22ef0fa3faa948825f88ca682ba10.svg";
export { ForwardRef as ReactComponent };